import { render, staticRenderFns } from "./ModalTabelaPrestador.vue?vue&type=template&id=eb6c5028"
import script from "./ModalTabelaPrestador.vue?vue&type=script&lang=ts"
export * from "./ModalTabelaPrestador.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports